import React, { useState, useEffect } from "react";
import Cookies from 'js-cookie';
import axios from 'axios';
// components

import Sidebar from "../components/CMS/Sidebar/Sidebar.js";
import HeaderWithoutStats from "../components/CMS/Headers/HeaderWithoutStats.js";
import Loader from "../components/CMS/Loader/Loader.js";

export default function Admin() {

    var commentimg1Url;
    var commentimg2Url;
    var commentimg3Url;
    var commentimg4Url;

    const data = [
        {
            "commentID": 1,
            "residentialName": "將軍澳廣場",
            "customerName": "陳先生",
            "comment": "很好",
            "imgUrl": "d"
        },
        {
            "commentID": 2,
            "residentialName": "康瑞苑",
            "customerName": "陳先生",
            "comment": "陳先生說很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好",
            "imgUrl": "d"
        },
        {
            "commentID": 3,
            "residentialName": "荔灣花園",
            "customerName": "陳先生",
            "comment": "很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好"
        },
        {
            "commentID": 4,
            "residentialName": "荔灣花園",
            "customerName": "陳先生",
            "comment": "很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好很好"
        },
    ]

    const [datax, setData] = useState(data);
    const [loading, setLoading] = useState(true);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [error, setError] = useState(null);
    const token = localStorage.getItem("token");
    var userLogged = false;

    function validateLogin() {
        fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/validate', {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
        })
          .then(response => {
            if (response.status == 200) {
              // console.log("is true")
            } else {
              window.location.href = '/cms/admin/login';
            }
          })
          .catch((e) => {
            window.location.href = '/cms/admin/login';
          });
      }

    async function getData() {
        fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/comments')
            .then(response => response.json())
            .then((usefulData) => {
                const d = [JSON.parse(usefulData.data[0]), JSON.parse(usefulData.data[1]), JSON.parse(usefulData.data[2]), JSON.parse(usefulData.data[3])]

                setLoading(false);
                setData(d);
                // console.log(d)
            })
            .catch((error) => {
                alert("發生錯誤, 請重新載入")
            });
    }

    useEffect(() => {
        validateLogin();
        getData();

    }, []);

    const coverImg_changed = (e, commentId) => {
        var src = URL.createObjectURL(e.target.files[0]);
        document.getElementById(commentId).setAttribute('src', src);
    }

    async function setCommentImgUrlById(url, commentID) {

        if (commentID === 'comment1Img')
            commentimg1Url = url
        if (commentID === 'comment2Img')
            commentimg2Url = url
        if (commentID === 'comment3Img')
            commentimg3Url = url
        if (commentID === 'comment4Img')
            commentimg4Url = url
    }

    async function uploadCommentImgToImgur(file, commentID) {

        // console.log(commentID);
        // console.log(file);

        const formData = new FormData();
        formData.append("file", file);
        await fetch(process.env.REACT_APP_ESERVICE_HK_API_LINK, {
            method: "POST",
            body: formData,
        }).then((response) => response.json())
            .then((data) => {
                setCommentImgUrlById(data.url, commentID)
            })
    }

    async function updateAllComments() {

        var file1 = document.getElementById("comment1ImgFile").files[0];
        var file2 = document.getElementById("comment2ImgFile").files[0];
        var file3 = document.getElementById("comment3ImgFile").files[0];
        var file4 = document.getElementById("comment4ImgFile").files[0];

        var residentialName1 = document.getElementById("residentialName1");
        var customerName1 = document.getElementById("customerName1");
        var comment1 = document.getElementById("comment1");
        var residentialName2 = document.getElementById("residentialName2");
        var customerName2 = document.getElementById("customerName2");
        var comment2 = document.getElementById("comment2");
        var residentialName3 = document.getElementById("residentialName3");
        var customerName3 = document.getElementById("customerName3");
        var comment3 = document.getElementById("comment3");
        var residentialName4 = document.getElementById("residentialName4");
        var customerName4 = document.getElementById("customerName4");
        var comment4 = document.getElementById("comment4");


        if (file1 !== undefined)
            await uploadCommentImgToImgur(file1, "comment1Img");
        else
            commentimg1Url = document.getElementById("comment1Img").src;
        if (file2 !== undefined)
            await uploadCommentImgToImgur(file2, "comment2Img");
        else
            commentimg2Url = document.getElementById("comment2Img").src;
        if (file3 !== undefined)
            await uploadCommentImgToImgur(file3, "comment3Img");
        else
            commentimg3Url = document.getElementById("comment3Img").src;
        if (file4 !== undefined)
            await uploadCommentImgToImgur(file4, "comment4Img");
        else
            commentimg4Url = document.getElementById("comment4Img").src;

        // console.log("url1 " + commentimg1Url)
        // console.log("url2 " + commentimg2Url)
        // console.log("url3 " + commentimg3Url)
        // console.log("url4 " + commentimg4Url)
        // console.log("residentialName1 " + residentialName1.value)
        // console.log("customerName1 " + customerName1.value)
        // console.log("comment1 " + comment1.value)
        // console.log("residentialName2 " + residentialName2.value)
        // console.log("customerName2 " + customerName2.value)
        // console.log("comment2 " + comment2.value)
        // console.log("residentialName3 " + residentialName3.value)
        // console.log("customerName3 " + customerName3.value)
        // console.log("comment3 " + comment3.value)
        // console.log("residentialName4 " + residentialName4.value)
        // console.log("customerName4 " + customerName4.value)
        // console.log("comment4 " + comment4.value)

        if (residentialName1.value == "" || customerName1.value == "" || comment1.value == "" || commentimg1Url == "" ||
            residentialName2.value == "" || customerName2.value == "" || comment2.value == "" || commentimg2Url == "" ||
            residentialName3.value == "" || customerName3.value == "" || comment3.value == "" || commentimg3Url == "" ||
            residentialName4.value == "" || customerName4.value == "" || comment4.value == "" || commentimg4Url == "") {
            alert("資料不能留空!")
        } else {
            var c1 = {
                "commentID": 1,
                "residentialName": residentialName1.value,
                "customerName": customerName1.value,
                "comment": comment1.value,
                "imgUrl": commentimg1Url
            };
            var c2 = {
                "commentID": 2,
                "residentialName": residentialName2.value,
                "customerName": customerName2.value,
                "comment": comment2.value,
                "imgUrl": commentimg2Url
            };
            var c3 = {
                "commentID": 3,
                "residentialName": residentialName3.value,
                "customerName": customerName3.value,
                "comment": comment3.value,
                "imgUrl": commentimg3Url
            };
            var c4 = {
                "commentID": 4,
                "residentialName": residentialName4.value,
                "customerName": customerName4.value,
                "comment": comment4.value,
                "imgUrl": commentimg4Url
            };


            const param = {
                user_comment_1: JSON.stringify(c1),
                user_comment_2: JSON.stringify(c2),
                user_comment_3: JSON.stringify(c3),
                user_comment_4: JSON.stringify(c4),
            }

            // console.log(JSON.stringify(param))

            // console.log("Token", token)
            const instance = axios.create({
                baseURL: process.env.REACT_APP_API_BASE_LINK,
                headers: {
                    "Authorization": token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            instance.post(`/v1/fookchong/cms/updateUserComments`, {
                user_comment_1: param.user_comment_1,
                user_comment_2: param.user_comment_2,
                user_comment_3: param.user_comment_3,
                user_comment_4: param.user_comment_4
            }).then(function (response) {
                setShowSuccessModal(true);
            }).catch(function (error) {
                alert("發生錯誤, 請重新提交更新請求")
            })

            // fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/updateUserComments', {
            //     method: "POST",
            //     credentials: 'include',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         Cookie: `JSESSIONID=${cookie}`
            //     },
            //     body: JSON.stringify(param),
            // }).then(response => response.json())
            //     .then((usefulData) => {
            //         setShowSuccessModal(true);
            //     }).catch((error) => {
            //         alert("發生錯誤, 請重新提交更新請求")
            //     });
        }
    }
        return (
            <>
                <Sidebar />
                <div className="relative md:ml-64 bg-blueGray-100">
                    <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
                        <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
                            {/* Brand */}
                            <div
                                className="text-white text-xl uppercase lg:inline-block font-semibold"
                            >
                                留言管理
                            </div>
                        </div>
                    </nav>
                    {/* Header */}
                    <HeaderWithoutStats />
                    <div className="px-4 md:px-10 mx-auto w-full">
                        {
                            (loading == true)
                                ? <Loader />
                                :
                                <div className="-mt-4">
                                    <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-5">
                                        <div className="rounded overflow-hidden shadow ">
                                            <figure className="">
                                                <img id="comment1Img" className="w-full h-56 rounded-lg" src={datax[0].imgUrl || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                                                <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>

                                                <input onChange={e => coverImg_changed(e, "comment1Img")} id="comment1ImgFile" type="file" accept=".png, .jpg, .jpeg" name="comment1Img" className="m-4 focus:outline-none" />
                                            </figure>
                                            <div className="px-6 py-4">
                                                <div className="lg:col-span-2">
                                                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-4">
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="residentialName1" className="uppercase font-semibold">住宅名稱</label>
                                                            <input type="text" name="residentialName1" id="residentialName1" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[0].residentialName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="customerName1" className="uppercase font-semibold">客人名稱</label>
                                                            <input type="text" name="customerName1" id="customerName1" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[0].customerName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="comment1" className="uppercase font-semibold ">留言</label>
                                                            <textarea id="comment1"
                                                                rows="4"
                                                                defaultValue={datax[0].comment || ''}
                                                                className="mt-1 resize-none block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-500 focus:ring-blue-500 focus:border--500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder=""></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="rounded overflow-hidden shadow ">
                                            <figure className="">
                                                <img id="comment2Img" className="w-full h-56 rounded-lg" src={datax[1].imgUrl || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                                                <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>

                                                <input onChange={e => coverImg_changed(e, "comment2Img")} id="comment2ImgFile" type="file" name="comment2Img" accept=".png, .jpg, .jpeg" className="m-4 focus:outline-none" />
                                            </figure>
                                            <div className="px-6 py-4">
                                                <div className="lg:col-span-2">
                                                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-4">
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="residentialName2" className="uppercase font-semibold">住宅名稱</label>
                                                            <input type="text" name="residentialName2" id="residentialName2" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[1].residentialName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="customerName2" className="uppercase font-semibold">客人名稱</label>
                                                            <input type="text" name="customerName2" id="customerName2" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[1].customerName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="comment2" className="uppercase font-semibold ">留言</label>
                                                            <textarea id="comment2"
                                                                rows="4"
                                                                defaultValue={datax[1].comment || ''}
                                                                className="mt-1 resize-none block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-500 focus:ring-blue-500 focus:border--500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder=""></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="rounded overflow-hidden shadow ">
                                            <figure className="">
                                                <img id="comment3Img" className="w-full h-56 rounded-lg" src={datax[2].imgUrl || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                                                <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>

                                                <input onChange={e => coverImg_changed(e, "comment3Img")} id="comment3ImgFile" type="file" name="comment3Img" accept=".png, .jpg, .jpeg" className="m-4 focus:outline-none" />
                                            </figure>
                                            <div className="px-6 py-4">
                                                <div className="lg:col-span-2">
                                                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-4">
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="residentialName3" className="uppercase font-semibold">住宅名稱</label>
                                                            <input type="text" name="residentialName3" id="residentialName3" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[2].residentialName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="customerName3" className="uppercase font-semibold">客人名稱</label>
                                                            <input type="text" name="customerName3" id="customerName3" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[2].customerName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="comment3" className="uppercase font-semibold ">留言</label>
                                                            <textarea id="comment3"
                                                                rows="4"
                                                                defaultValue={datax[2].comment || ''}
                                                                className="mt-1 resize-none block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-500 focus:ring-blue-500 focus:border--500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder=""></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="rounded overflow-hidden shadow ">
                                            <figure className="">
                                                <img id="comment4Img" className="w-full h-56 rounded-lg" src={datax[3].imgUrl || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                                                <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>

                                                <input onChange={e => coverImg_changed(e, "comment4Img")} id="comment4ImgFile" type="file" name="comment4Img" accept=".png, .jpg, .jpeg" className="m-4 focus:outline-none" />
                                            </figure>
                                            <div className="px-6 py-4">
                                                <div className="lg:col-span-2">
                                                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-4">
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="residentialName4" className="uppercase font-semibold">住宅名稱</label>
                                                            <input type="text" name="residentialName4" id="residentialName4" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[3].residentialName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="customerName4" className="uppercase font-semibold">客人名稱</label>
                                                            <input type="text" name="customerName4" id="customerName4" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={datax[3].customerName || ''} />
                                                        </div>
                                                        <div className="md:col-span-5 text-left">
                                                            <label htmlFor="comment4" className="uppercase font-semibold ">留言</label>
                                                            <textarea id="comment4"
                                                                rows="4"
                                                                defaultValue={datax[3].comment || ''}
                                                                className="mt-1 resize-none block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-500 focus:ring-blue-500 focus:border--500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder=""></textarea>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div className="-mt-4 mb-4 flex items-center justify-center">
                                        <button className="focus:outline-none bg-transparent hover:bg-indigo-500 text-indigo-700 font-semibold hover:text-white py-2 px-4 border border-indigo-500 hover:border-transparent rounded"
                                            onClick={() => updateAllComments()}
                                        >
                                            更新
                                        </button>
                                    </div>
                                </div>
                        }

                    </div>

                    {showSuccessModal ? (
                        <>
                            <div
                                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                            >
                                <div className="relative w-auto ">
                                    {/*content*/}
                                    <div className="border-0 rounded-lg shadow relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                        <div className="flex items-start justify-between p-2">

                                            <button type="button" className="focus:outline-none text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                                onClick={() => {
                                                    setShowSuccessModal(false);
                                                    window.location.reload();
                                                }}
                                            >
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                            </button>
                                        </div>

                                        {/*body*/}
                                        <div className="px-8 ">

                                            <div className="mb-4 sm:flex">
                                                <div className="flex items-center justify-center flex-none w-12 h-12 mx-auto bg-green-200 rounded-full">
                                                    <svg className="w-6 h-6 fill-current text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" /></svg>
                                                </div>
                                                <div className="text-center sm:ml-4 sm:text-left">
                                                    <h5 className="mt-2 text-lg font-medium text-gray-800">
                                                        成功更新留言!
                                                    </h5>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                        </>
                    ) : null}

                </div>
            </>
        );
}
